/*** IMPORTS FROM imports-loader ***/
var define = false;

import Cookies from 'js-cookie';

const NsfwBanner = {
    bannerDiv: null,
    init: function() {
      this.bannerDiv = document.querySelector('.nsfw-banner');
      console.log(this.bannerDiv);

      if (Cookies.get('nsfw-accept')) {
        this.bannerDiv.classList.add('hidden');
      } else {
        this.initCloseListener();
        this.initAcceptListener();
      }
    },
    initCloseListener: function() {
        const closeButton = this.bannerDiv.querySelector('a.close-icon');

        if (this.bannerDiv && closeButton) {
            closeButton.addEventListener('click', (evt) => {
                evt.preventDefault();
                this.bannerDiv.classList.add('hidden');
            });
        }
    },
    initAcceptListener: function() {
        const acceptButton = this.bannerDiv.querySelector('button.accept');

        if (this.bannerDiv && acceptButton) {
            acceptButton.addEventListener('click', (evt) => {
                evt.preventDefault();
                Cookies.set('nsfw-accept', 'true', { expires: 365 });
                this.bannerDiv.classList.add('hidden');
            });
        }
    },
};

export default NsfwBanner;

